import { createContext, type PropsWithChildren, use, useMemo } from 'react'
import { useMedia } from 'react-use'
import { useUdsToken } from '../../utils/styling/use-token'

const BreakpointContext = createContext({
  isDesktop: false,
  isTablet: false,
  isMobile: false,
  isTabletOrGreater: false,
  isMobileOrGreater: false,
})

export function BreakpointProvider({ children }: PropsWithChildren) {
  const mqDesktop = useUdsToken<string>('primitives_breakpoint_l_min')
  const mqTabletMax = useUdsToken<string>('primitives_breakpoint_m_max')
  const mqTabletMin = useUdsToken<string>('primitives_breakpoint_m_min')
  const mqTabletOrGreater = useUdsToken<string>('primitives_breakpoint_m_min')
  const mqMobileIrGreater = useUdsToken<string>('primitives_breakpoint_s_min')

  const isMobileOrGreater = useMedia(`(min-width: ${mqMobileIrGreater}px)`, false)
  const isTabletOrGreater = useMedia(`(min-width: ${mqTabletOrGreater}px)`, false)
  const isDesktop = useMedia(`(min-width: ${mqDesktop}px)`, false)
  const isTablet = useMedia(`(min-width: ${mqTabletMin}px) and (max-width: ${mqTabletMax}px)`, false)
  const isMobile = !isTablet && !isDesktop

  const value = useMemo(
    () => ({
      isMobileOrGreater,
      isTabletOrGreater,
      isDesktop,
      isTablet,
      isMobile,
    }),
    [isMobileOrGreater, isTabletOrGreater, isDesktop, isTablet, isMobile],
  )

  return (
    <BreakpointContext value={value}>
      {children}
    </BreakpointContext>
  )
}

export const useBreakpoints = () => use(BreakpointContext)
